import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { CATEGORIES, TOP_POSITION_COUNT } from "helpers/analyzeConstants"
import { getOnly, getFocusedChartLine } from "./selectors"
import { getSelectedOption, getFilteredData, getCategoryItemsSubset, getDrift, getSelectedFactorCategoryId, getSelectedFactorCategoryName, getAllCategoryItems } from "./selectors/data"
import { getFileName } from "./selectors/file"
import { getFirstBetaDate, getBeta } from "./selectors/beta"
import { hasReferenceEquity } from "./selectors/concentration"
import { getMissingDataFiles, betasAreMissing, betasSubQuery } from "selectors/missingDataFiles"
import { VIEW_TYPES } from "helpers/base"
import { convertPositionSetType } from "helpers/compositeSecurities"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    missingDataFiles: getMissingDataFiles(state, props),
  }),
  required: ["account", "positionSetId", "positionSetType", "modelId"],
  data: [{
    resource: "compositeBeta",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, driftDates, viewType, startDate, base, baseSignature, baseStartDate, segment, missingDataFiles, expand }) => {
      if (!missingDataFiles || betasAreMissing(missingDataFiles, modelId)) { return null }
      let from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      if (viewType === VIEW_TYPES.ACTIVE && from < baseStartDate) {
        from = baseStartDate
      }

      return {
        id: `compositeBeta-${modelId}${positionSetId}${positionSetType}${from}${to}${viewType}${baseSignature}${JSON.stringify(segment)}${expand}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model(id: $modelId) {
            simulation(positionSet: $positionSet, from: $from, to: $to, base: $base, interval: AUTO) {
              ${betasSubQuery(missingDataFiles, ["date", "rolledOverFrom"])}
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          from,
          to,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }, {
    resource: "compositeConcentration",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, startDate, endDate, segment, expand }) => {
      return {
        id: `compositeConcentration-${modelId}${positionSetId}${positionSetType}${startDate}${endDate}${JSON.stringify(segment)}${expand}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!) {
          model(id: $modelId) {
            simulation(positionSet: $positionSet, from: $from, to: $to, interval: AUTO) {
              composition(scaleFormat: PERCENT_EQUITY_GMV) {
                date
                gmv
                referenceEquity
                positionsCount
                concentration {
                  max
                  top(count: ${TOP_POSITION_COUNT})
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          from: startDate,
          to: endDate,
        },
      }
    },
  }, MODEL_METADATA_QUERY],
  mapStateToProps: (state, props) => ({
    data: getFilteredData(state, props),
    beta: getBeta(state, props),
    items: getCategoryItemsSubset(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    focusedChartLine: getFocusedChartLine(state),
    only: getOnly(state, props),
    options: CATEGORIES,
    drift: getDrift(state, props),
    firstDate: getFirstBetaDate(state, props),
    fileName: getFileName(state, props),
    factorCategoryId: getSelectedFactorCategoryId(state, props),
    factorCategoryName: getSelectedFactorCategoryName(state, props),
    selectedOption: getSelectedOption(state, props),
    refEquityOverride: hasReferenceEquity(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
  },
})
